import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GridStateService {
    public paginationPage: number = 0;
}